import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Button, Modal, Form, Card, Row, Col } from "react-bootstrap";
import Axios from "axios";

//ACTIONS
import * as GS_navSettingsActions from "../../../../../store/actions/globalSettings/GS_navSettings";

//STYLES
import * as LinksStyles from "../styles/links";

function Links() {
    const dispatch = useDispatch();

    const modalDefaults = {
        open: false,
        values: {
            title: "",
            link: ""
        },
        valids: {
            title: false,
            link: false
        },
        touched: {
            title: false,
            link: false
        },
        wholeFormValid: false,

        editMode: false,
        editID: 0
    };

    const [linksHeading, setLinksHeading] = useState("");
    const [linksHeadingUpdateButton, setLinksHeadingUpdateButton] = useState("primary");
    const [modal, setModal] = useState(modalDefaults);
    const [links, setLinks] = useState([]);

    const [modalYN, setModalYN] = useState({
        open: false,
        heading: "",
        message: "",
        acceptFunction: "",
        acceptName: "",
        showAccept: false,
        cancelName: "",
        showCancel: false
    });

    function handleModalYNClose() {
        setModalYN((prevState) => {
            return { ...prevState, open: false };
        });
    }

    function handleCloseModal() {
        setModal(modalDefaults);
    }

    useEffect(() => {
        dispatch(GS_navSettingsActions.UpdateTitle("3D Printing Service - Links"));
        dispatch(GS_navSettingsActions.UpdateSelected("Features"));
        dispatch(GS_navSettingsActions.UpdateSubSelected("3D Printing Service"));

        loadLinks();
    }, []);

    function loadLinks() {
        Axios.post("/pods/3dPrintingShop/settings/loadLinks")
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setLinks(data.links);
                    setLinksHeading(data.linksHeading);
                }
            })
            .catch((err) => console.log(err));
    }

    function handleOpenModal() {
        setModal((prevState) => {
            return { ...prevState, open: true };
        });
    }

    function handleOnTocuhed(event) {
        const { name } = event.target;

        const temp = { ...modal.touched };

        temp[name] = true;

        setModal((prevState) => {
            return { ...prevState, touched: temp };
        });
    }

    function handleTextOnChange(event) {
        const { name, value } = event.target;

        const valuesTemp = { ...modal.values };
        const validsTemp = { ...modal.valids };

        let isValid = false;
        if (value != "") {
            isValid = true;
        }

        valuesTemp[name] = value;
        validsTemp[name] = isValid;

        const allTrue = Object.keys(validsTemp).every(function (k) {
            return validsTemp[k] === true;
        });

        setModal((prevState) => {
            return { ...prevState, values: valuesTemp, valids: validsTemp, wholeFormValid: allTrue };
        });
    }

    function switchAllTouches() {
        const newTouches = Object.assign(...Object.keys(modal.touched).map((k) => ({ [k]: true })));
        setModal((prevState) => {
            return { ...prevState, touched: newTouches };
        });
    }

    function handleAddButton() {
        if (!modal.wholeFormValid) {
            switchAllTouches();
        } else {
            const data = { title: modal.values.title, link: modal.values.link };
            Axios.post("/pods/3dPrintingShop/settings/addLink", data)
                .then((res) => {
                    const data = res.data;
                    if (data.error == "null") {
                        setModal(modalDefaults);
                        loadLinks();
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    function handleOpenUpdate(id) {
        const link = links.find((li) => li.uuid == id);

        const values = {
            title: link.title,
            link: link.link
        };
        const valids = {
            title: true,
            link: true
        };
        const touched = {
            title: true,
            link: true
        };

        setModal((prevState) => {
            return { ...prevState, editID: id, editMode: true, values, valids, touched, open: true };
        });
    }

    function handleUpdateButton() {
        const data = { title: modal.values.title, link: modal.values.link, editID: modal.editID };
        Axios.post("/pods/3dPrintingShop/settings/updateLink", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setModal(modalDefaults);
                    loadLinks();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleDeleteButton() {
        setModalYN({
            heading: "Delete Link",
            message: "Are you sure you want to delete this link?",
            showAccept: true,
            acceptName: "Yes",
            acceptFunction: handleAcceptDelete.bind(this, modal.editID),
            showCancel: true,
            cancelName: "No",
            open: true
        });
    }

    function handleAcceptDelete(id) {
        const data = { uuid: id };
        Axios.post("/pods/3dPrintingShop/settings/deleteLink", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setModal(modalDefaults);
                    handleModalYNClose();
                    loadLinks();
                }
            })
            .catch((err) => console.log(err));
    }

    function handleChangeLinkHeading(event) {
        const { value } = event.target;

        setLinksHeading(value);
    }

    function handleUpdateLinkTitle() {
        const data = { title: linksHeading };
        Axios.post("/pods/3dPrintingShop/settings/updateLinksHeading", data)
            .then((res) => {
                const data = res.data;
                if (data.error == "null") {
                    setLinksHeadingUpdateButton("success");

                    setTimeout(() => {
                        setLinksHeadingUpdateButton("primary");
                    }, 1000);
                }
            })
            .catch((err) => console.log(err));
    }

    return (
        <div style={LinksStyles.body}>
            <Row>
                <Col>
                    Link Heading: <br />
                    <div style={LinksStyles.headingContainer}>
                        <div style={LinksStyles.headingTextContainer}>
                            <Form.Control type="text" placeholder="Links" value={linksHeading} onChange={handleChangeLinkHeading} maxLength={50} />
                            <p style={LinksStyles.counter}>{linksHeading.length}/50</p>
                        </div>
                        <div>
                            <Button variant={linksHeadingUpdateButton} onClick={handleUpdateLinkTitle}>
                                Update
                            </Button>
                            <p style={LinksStyles.hidden}>hidden</p>
                        </div>
                    </div>
                </Col>
                <Col style={LinksStyles.columRight}>
                    <Button onClick={handleOpenModal}>Add Link</Button>
                </Col>
            </Row>
            <br />
            <p style={LinksStyles.editNotice}>DOUBLE CLICK TO EDIT A LINK</p>
            {links.map((link, index) => {
                return (
                    <div key={index}>
                        <Card style={LinksStyles.cardStyle} onDoubleClick={handleOpenUpdate.bind(this, link.uuid)}>
                            <Card.Body>
                                <Row>
                                    <Col>Title: {link.title}</Col>
                                    <Col>Link: {link.link}</Col>
                                </Row>
                            </Card.Body>
                        </Card>
                        <br />
                    </div>
                );
            })}
            <Modal show={modal.open} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>{modal.editMode ? "Edit Link" : "Add Link"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form.Group>
                        <Form.Label>Title:</Form.Label>
                        <Form.Control
                            isInvalid={modal.touched.title && !modal.valids.title ? true : false}
                            type="text"
                            name="title"
                            onBlur={handleOnTocuhed}
                            onChange={handleTextOnChange}
                            value={modal.values.title}
                            maxLength={50}
                        />
                        <Form.Control.Feedback type="invalid">Please enter a title!</Form.Control.Feedback>
                        <p style={LinksStyles.counter}>{modal.values.title.length}/50</p>
                    </Form.Group>
                    <br />
                    <Form.Group>
                        <Form.Label>URL:</Form.Label>
                        <Form.Control
                            isInvalid={modal.touched.link && !modal.valids.link ? true : false}
                            type="text"
                            name="link"
                            onBlur={handleOnTocuhed}
                            onChange={handleTextOnChange}
                            value={modal.values.link}
                            maxLength={200}
                        />
                        <Form.Control.Feedback type="invalid">Please enter an URL!</Form.Control.Feedback>
                        <p style={LinksStyles.counter}>{modal.values.link.length}/200</p>
                    </Form.Group>
                    {modal.editMode && (
                        <div>
                            <hr />
                            <Row>
                                <Col>
                                    <Button onClick={handleDeleteButton}>Delete</Button>
                                </Col>
                                <Col style={LinksStyles.columRight}>
                                    <Button onClick={handleUpdateButton}>Update</Button>
                                    <Button onClick={handleCloseModal}>Close</Button>
                                </Col>
                            </Row>
                        </div>
                    )}
                </Modal.Body>
                {!modal.editMode && (
                    <Modal.Footer>
                        <Button onClick={handleAddButton}>Add</Button>
                        <Button onClick={handleCloseModal}>Close</Button>
                    </Modal.Footer>
                )}
            </Modal>
            <Modal show={modalYN.open} onHide={handleModalYNClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalYN.heading}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalYN.message}</Modal.Body>
                <Modal.Footer>
                    {modalYN.showAccept ? (
                        <div>
                            <Button variant="primary" onClick={modalYN.acceptFunction}>
                                {modalYN.acceptName}
                            </Button>
                        </div>
                    ) : null}
                    {modalYN.showCancel ? (
                        <div>
                            <Button variant="primary" onClick={handleModalYNClose}>
                                {modalYN.cancelName}
                            </Button>
                        </div>
                    ) : null}
                </Modal.Footer>
            </Modal>
        </div>
    );
}
export default Links;
